import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { white } from 'styles/colors'
import { searchFocus, searchBlur } from 'actions'

import { placeholder, borderColor, inputBackground } from 'styles/colors'
import { title } from 'styles/texts'
import withSuggestions from 'components/withSuggestions'

const Wrapper = styled.div`
  position: relative;
`

const InputField = styled.input`
  ${title};
  background: ${inputBackground};
  border: 1px solid ${borderColor};
  border-radius: 4px;
  padding: 9px 13px;
  width: 100%;
  -webkit-appearance: none;
  width: 100%;
  background-color: ${white};
  border: none;
  padding-right: 44px;
  outline: none;
  margin: 0;

  &::placeholder {
    color: ${placeholder};
  }
`

const SearchIcon = styled.img`
  position: absolute;
  top: 50%;
  right: 13px;
  transform: translate(0, -50%);
`

class SearchField extends React.Component {
  componentDidUpdate(prevProps) {
    if (!this.props.isFocused && prevProps.isFocused) {
      this.el.blur()
    }
    if (this.props.isFocused && !prevProps.isFocused) {
      this.el.focus()
    }
  }

  render() {
    return (
      <Wrapper>
        <InputField
          type="text"
          placeholder="Søk Node.js, NTNU eller Arne"
          {...this.props}
          innerRef={el => {
            this.props.innerRef(el)
            this.el = el
          }}
          onFocus={() => {
            this.props.onFocus()
            this.props.searchFocus()
          }}
          onBlur={() => {
            this.props.onBlur()
            this.props.searchBlur()
          }}
        />
        <SearchIcon src="/icons/search.svg" alt="" />
      </Wrapper>
    )
  }
}

const mapStatToProps = state => ({
  isFocused: state.search.focus,
})

const mapDispathToProps = { searchFocus, searchBlur }

export default withSuggestions(
  connect(mapStatToProps, mapDispathToProps)(SearchField),
  'search',
  10
)



// WEBPACK FOOTER //
// ./src/components/Header/SearchField/SearchField.js